<template>
  <div class="ml-6 mr-6 mt-2" :style="navbarWithName ? 'margin-left: 150px !important; margin-right: auto !important;' : ''">
    <v-alert v-if="alert" class="mb-3" border="top" :color="colorAlert" dark>
      {{ message }}
    </v-alert>
    <!--TOPIC DAN PEROIDE BERITA-->
    <v-layout
      :class="{
        'd-flex ma-0 pa-0 ml-1 justify-center': (showDateStart == '' && showDateEnd == '') || (showDateStart != '' && showDateEnd != '' && isShowDate == false),
        'd-flex ma-0 pa-0 ml-1': showDateStart != '' && showDateEnd != '' && isShowDate == true
      }"
      :style="navbarWithName ? 'margin-left: 10px !important;' : ''"
      row
      wrap
    >
      <v-col class="d-flex ma-0 pa-0" cols="12" sm="2">
        <v-select
          :items="topicsentiment"
          item-text="TOPIC"
          item-value="SEQ_ID"
          v-model="selectedTopic"
          class="elevation-0 shadow-0"
          color="var(--color-theme)"
          :item-color="themeItemColor"
          label="Topic"
          dense
          outlined
          rounded
          @change="statusFilter = '', parameter_proses_topic()"
        ></v-select>
      </v-col>

      <v-col class="d-flex ma-0 pa-0 mx-3" cols="12" sm="2">
        <v-select
          :items="topickeywordsentiment"
          v-model="selectedTopic2"
          class="elevation-0 shadow-0"
          color="var(--color-theme)"
          :item-color="themeItemColor"
          label="Keyword"
          dense
          outlined
          rounded
          @change="parameter_proses_keyword"
        ></v-select>
      </v-col>

      <v-col class="d-flex ma-0 pa-0" cols="12" sm="2">
        <v-select
          :items="periodeberita"
          v-model="selectedPeriode"
          class="elevation-0 shadow-0"
          color="var(--color-theme)"
          :item-color="themeItemColor"
          label="Periode"
          dense
          outlined
          rounded
          @change="parameter_proses_periode"
        >
          <template v-slot:append-item>
            <v-list-item>
              <v-list-item-title>
                <v-menu
                  v-model="menu"
                  :close-on-content-click="false"
                  :nudge-width="200"
                  offset-x
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-bind="attrs"
                      v-on="on"
                      small
                      dark
                      width="120"
                      color="var(--color-theme)"
                    >
                      Custom
                    </v-btn>
                  </template>
                  <v-card>
                    <v-row class="pa-8" justify="space-around">
                      <v-date-picker
                        v-model="dateStart"
                        :show-current="false"
                        class="custom-date-picker"
                        color="var(--color-theme)"
                        @change="showPeriodeDate"
                      ></v-date-picker>
                      <v-date-picker
                        v-model="dateEnd"
                        :show-current="false"
                        class="ml-8 custom-date-picker"
                        color="var(--color-theme)"
                        @change="showPeriodeDate"
                      ></v-date-picker>
                    </v-row>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="#000" text @click="menu = false">
                        Cancel
                      </v-btn>
                      <v-btn color="var(--color-theme)" text @click="menu = false, parameter_proses_custom()">
                        Set
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-menu>
              </v-list-item-title>
            </v-list-item>
          </template>
        </v-select>
      </v-col>

      <v-col
        v-if="showDateStart != '' && showDateEnd != ''"
        class="d-flex ma-0 pa-0 mx-3"
        cols="12"
        sm="3"
      >
        <v-card height="40" outlined style="border-radius: 30px; width: 100%;">
          <v-card-text class="pa-2 px-4">
            <v-icon>mdi-calendar</v-icon>
            <span class="mt-2 ml-1">
              {{ showDateStart[1] + " " + showDateStart[0] + " " + showDateStart[2] }} - {{ showDateEnd[1] + " " + showDateEnd[0] + " " + showDateEnd[2] }}
            </span>
          </v-card-text>
        </v-card>
      </v-col>

      <!-- Button Hit API -->
      <v-col
        :class="{
          'd-flex ma-0 pa-0 ml-3': (showDateStart == '' && showDateEnd == '') || (showDateStart != '' && showDateEnd != '' && isShowDate == false),
          'd-flex ma-0 pa-0': showDateStart != '' && showDateEnd != '' && isShowDate == true
        }"
        cols="12"
        sm="1"
      >
        <v-btn
          color="var(--color-theme-secondary)"
          style="max-width: 100%;"
          height="40"
          dense
          dark
          rounded
          block
          @click="loadChartPie()"
        >
          <v-icon>mdi-magnify</v-icon>
          Search
        </v-btn>
      </v-col>
      <!-- End Button Hit API -->

      <v-col
        class="d-flex ma-0 pa-0 ml-3"
        cols="12"
        sm="1"
      >
        <v-btn
          v-if="isColorThemeSetneg"
          color="var(--color-theme)"
          style="max-width: 100%;"
          height="40"
          outlined
          rounded
          block
          @click="dialogConfirmReset = true"
        >
          <v-icon>mdi-reload</v-icon>
          Reset
        </v-btn>

        <v-btn
          v-else
          class="white--text"
          height="40"
          color="#a80202"
          variant="outlined"
          style="max-width: 100%;"
          rounded
          block
          @click="dialogConfirmReset = true"
        >
          <v-icon>mdi-reload</v-icon>
          Reset
        </v-btn>
      </v-col>
    </v-layout>

    <v-row wrap class="mb-6">
      <v-flex lg4 sm12 md12 xs12>
        <v-card :class="navbarWithName ? 'mx-5 mb-6 rounded-lg pa-4' : 'mx-4 mb-6 rounded-lg pa-4'" height="400px" flat>
          <div>
            <v-card-title>Sentiment Analysis</v-card-title>
            <apexchart
              :options="chartPie"
              :series="seriesdonut"
              class="mt-2"
              type="donut"
              width="370px"
              @dataPointSelection="filterBySentiment"
            ></apexchart>
          </div>
        </v-card>
      </v-flex>

      <v-flex lg4 sm12 md12 xs12>
        <v-card :class="navbarWithName ? 'mr-5 mb-6 rounded-lg' : 'mr-4 mb-6 rounded-lg'" height="400px" flat>
          <v-card-title style="position: relative; z-index: 1;">Media Share</v-card-title>
          <div style="margin-top: -40px; position: relative; z-index: 0;">
            <highcharts :options="chartOptionsRadial"></highcharts>
          </div>
        </v-card>
      </v-flex>

      <v-flex lg4 sm12 md12 xs12>
        <v-card :class="navbarWithName ? 'mr-2 mb-6 rounded-lg' : 'mr-2 mb-6 rounded-lg'" height="400px" flat>
          <v-card-title>Influencer</v-card-title>
          <div style="margin-top: -35px;">
            <v-col>
              <Toppersonbubble
                ref="topPersonComponent"
                :selectedTopic2="selectedTopic2"
                :selectedTopic="selectedTopic"
                :selectedPeriode="selectedPeriode"
                :statusFilter="statusFilter"
                :nerPersonSearch="nerPersonSearch"
                :nerOrganizationSearch="nerOrganizationSearch"
                :isClickBubleOrg="isClickBubleOrg"
                :isClickWord="isClickWord"
                :resetcolorClicked="resetcolorClicked"
                :updateSocket="updateSocket"
                @clicked="filterByBuble"
              ></Toppersonbubble>
            </v-col>
          </div>
        </v-card>
      </v-flex>
      <v-flex lg12 sm12 md12 xs12>
        <v-card :class="navbarWithName ? 'mx-5 mb-6 rounded-lg pa-4' : 'mx-4 mb-6 rounded-lg pa-4'" height="500px" flat>
          <v-card-title>
            Cluster Analysis
            <!-- Spacer untuk memisahkan judul dan tombol -->
            <v-spacer></v-spacer>
            <!-- Tombol Reset Zoom di sebelah kanan -->
            <v-btn @click="zoomOut" color="#a80202" variant="outlined" class="mt-4 white--text" rounded><v-icon>mdi-reload</v-icon> Reset Zoom</v-btn>
          </v-card-title>

          <!-- FoamTreeComponent -->
          <FoamTreeComponent ref="clustercarot"></FoamTreeComponent>
        </v-card>
      </v-flex>



      <v-flex lg6 sm12 md12 xs12>
        <v-card :class="navbarWithName ? 'mx-5 mb-6 rounded-lg pa-4' : 'mx-4 mb-6 rounded-lg pa-4'" height="500px" flat>
          <v-card-title>Content List</v-card-title>
          <!-- <FoamTreeComponent ref="clustercarot"></FoamTreeComponent> -->
        </v-card>
      </v-flex>

      <v-flex lg6 sm12 md12 xs12>
        <v-card :class="navbarWithName ? 'mr-2 mb-6 rounded-lg pa-4' : 'mr-2 mb-6 rounded-lg pa-4'" height="500px" flat>
          <v-card-title>Geolocation</v-card-title>
          <GChart
            :settings="{ packages: ['geochart'] }"
            type="GeoChart"
            :data="chartDataProv"
            :options="chartOptionsProv"
            :height="'100%'"
          ></GChart>
        </v-card>
      </v-flex>

      <v-dialog v-model="dialog" persistent max-width="290">
        <v-card>
          <v-card-title class="text-h6 font-weight-medium align-center justify-center">
            Page loading
          </v-card-title>
          <v-card-text class="body-1 align-center justify-center">
            Loading content, please wait
          </v-card-text>
          <v-card-title class="align-center justify-center">
            <v-progress-circular
              color="var(--color-theme)"
              :size="70"
              :width="7"
              indeterminate
            ></v-progress-circular>
          </v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="var(--color-theme)" text @click="dialog = false">
              cancel
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogFilterLogika" max-width="500px">
        <v-card style="overflow-x: hidden">
          <v-toolbar height="50px" color="#439EDF" dark>
            Filter logika
          </v-toolbar>
          <v-card-text class="pa-6 overflow-card" style="height: 400px; background-color:#F4F7FA;">
            <v-card flat style="background-color:#F4F7FA;" class="mb-4">
              <v-row class="ma-0 pa-0 my-3">
                <v-flex lg4>
                  <v-select
                    :items="itemsFilterLogika"
                    item-text="logic"
                    item-value="logic"
                    v-model="valueFilterLogika"
                    label="Logic Filter"
                    dense
                    outlined
                    @change="disableLogicFilter"
                  ></v-select>
                </v-flex>
                <v-flex lg4 class="mx-3">
                  <v-text-field
                    v-model="valueKataKunci"
                    label="Kata Kunci"
                    dense
                    outlined
                    v-on:input="updateKataKunci"
                  ></v-text-field>
                </v-flex>
                <v-flex v-if="listObjFilterLogika.length == 0" lg3>
                  <v-card-text class="d-flex ma-0 pa-0">
                    <v-btn icon @click="addFilterLogika()">
                      <v-icon color="primary">mdi-plus-circle</v-icon>
                    </v-btn>
                  </v-card-text>
                </v-flex>
              </v-row>
              <v-row v-for="(item, i) in listObjFilterLogika" :key="i" class="ma-0 pa-0 my-3">
                <v-flex lg4>
                  <v-select
                    :items="itemsSelectFilterLogika[i]"
                    item-text="logic"
                    item-value="logic"
                    v-model="listObjFilterLogika[i].operator"
                    dense
                    outlined
                    @change="changeSelectFilterLogika(listObjFilterLogika[i].operator, i)"
                  ></v-select>
                </v-flex>
                <v-flex lg4 class="mx-3">
                  <v-text-field
                    v-model="listObjFilterLogika[i].keyword_logic"
                    dense
                    outlined
                  ></v-text-field>
                </v-flex>
                <v-flex v-if="i == listObjFilterLogika.length - 1" lg3>
                  <v-card-text class="d-flex ma-0 pa-0">
                    <v-btn icon @click="addFilterLogikaInList(item, i)">
                      <v-icon color="primary">mdi-plus-circle</v-icon>
                    </v-btn>
                    <v-btn icon @click="deleteFilterLogika(i)">
                      <v-icon color="red">mdi-minus-circle</v-icon>
                    </v-btn>
                  </v-card-text>
                </v-flex>
              </v-row>
            </v-card>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions class="pa-3">
            <v-spacer></v-spacer>
            <v-btn text @click="dialogFilterLogika = false, finalObjFilterLogika()">
              Cancel
            </v-btn>
            <v-btn text color="#439EDF" @click="dialogFilterLogika = false, finalObjFilterLogika()">
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog
        v-model="dialogInfo"
        height="500"
        width="350"
      >
        <v-card
          class="pa-5"
          dark
          rounded="lg"
          color="#439EDF"
        >
          <v-btn
            class="ml-auto"
            style="position: absolute; top: 5px; right: 5px; color: white;"
            icon
            @click="dialogInfo = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>

          <v-card-text class="text-center" style="display: flex; flex-direction: column; align-items: center; justify-content: center; padding: 20px;">
            <h3 class="white--text mb-4">Keyword Search Results</h3>
            <p class="white--text">
              Topic: <strong>{{ selectedTopicTotalCollectedData }}</strong> <br>
              From: <strong>{{ startDateInfo }}</strong> to <strong>{{ endDateInfo }}</strong>
            </p>
          </v-card-text>
        </v-card>
      </v-dialog>

      <v-dialog
        v-model="dialogConfirmReset"
        width="330px"
      >
        <v-card
          class="text-center align-center justify-center pa-6 rounded-lg"
          width="330px"
        >
          <v-btn
            class="ma-0 pa-0"
            color="#aaa"
            style="position: absolute; top: 10px; right: 10px;"
            icon
            small
            @click="dialogConfirmReset = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>

          <v-avatar color="#eee" style="border: 2px solid #ddd;" size="80">
            <v-icon class="white--text" size="80">
              mdi-check
            </v-icon>
          </v-avatar>

          <h1 class="mt-2 text-center text-h6 align-center justify-center">
            Are you sure?
          </h1>

          <v-card-text class="align-center justify-center mt-2">
            Are you sure you want to reset?
          </v-card-text>

          <v-divider class="mt-4"></v-divider>

          <v-card-actions class="align-center justify-center">
            <v-btn
              color="#0471A5"
              width="120px"
              height="40px"
              style="borderRadius: 8px"
              size="large"
              dark
              outlined
              @click="dialogConfirmReset = false"
            >
              Cancel
            </v-btn>
            <v-btn
              class="my-3"
              width="120px"
              height="40px"
              style="borderRadius: 8px"
              color="#e30700"
              size="large"
              dark
              @click="
                dialogConfirmReset = false,
                statusFilter = '',
                nerPersonSearch = '',
                nerOrganizationSearch = '',
                isClickBuble = '',
                resetcolorClicked = true,
                loadTopic(),
                parameter_proses_periode(),
                filterReset()
              "
            >
              Reset
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <div>
        <Notification ref="alert"></Notification>
      </div>
    </v-row>
  </div>
</template>

<script>
import axios from "axios";
// import io from 'socket.io-client';
//import VueApexCharts from 'vue-apexcharts'
// import { FoamTree } from "@carrotsearch/foamtree";
import Toppersonbubble from '@/components/Toporgbubbleinfluncer';
import FoamTreeComponent from '@/components/ClusterCarrot';
import { decryptionData, generate_filterdate } from '@/components/utils/utils.js';

import Notification from '@/components/Notification';
import { mapGetters } from 'vuex';
// let ipSocket = process.env.VUE_APP_API;

export default {
  components: {
    //apexcharts: VueApexCharts,
    FoamTreeComponent,
    Toppersonbubble,
    Notification: Notification
  },
  data: function() {
    return {
      dialogConfirmReset: false,
      dialogInfo: false,
      startDateInfo: "",
      endDateInfo: "",
      chartOptionsRadial: {
        colors: ['#FFD700', '#C0C0C0', '#CD7F32'],
        chart: {
          type: 'column',
          inverted: true,
          polar: true,
          height: '320px'
        },
        credits: {
          enabled: false
        },
        legend: {
          enabled: false
        },
        title: {
          text: '',
          align: 'left',
          useHTML: true,
          y: 35
        },
        tooltip: {
          outside: true,
          formatter: function() {
            // Customize the tooltip content
            return this.x + ': ' + this.y;
          }
        },
        pane: {
          size: '120%',
          innerSize: '20%',
          endAngle: 270
        },
        xAxis: {
          tickInterval: 1,
          labels: {
            align: 'right',
            useHTML: true,
            allowOverlap: true,
            step: 1,
            y: 3,
            style: {
              fontSize: '13px'
            }
          },
          lineWidth: 0,
          gridLineWidth: 0,
          categories: []
        },
        yAxis: {
          visible: false,
          lineWidth: 0,
          tickInterval: 25,
          reversedStacks: false,
          endOnTick: true,
          showLastLabel: true,
          gridLineWidth: 0
        },
        plotOptions: {
          visible: false,
          column: {
            stacking: 'normal',
            borderWidth: 0,
            pointPadding: 0,
            groupPadding: 0.15,
          }
        },
        series: [{
          data: [0, 0],
          colorByPoint: true,
          colors: ['#1ab7ea', '#0084ff', '#0084ff', '#0084ff']
        }]
      },
      // selectedDataSource: 0,
      // itemsDataSource: [
      //   {
      //     text: "News",
      //     value: 0,
      //   },
      //   {
      //     text: "Twitter",
      //     value: 1,
      //   },
      //   {
      //     text: "Youtube",
      //     value: 2,
      //   },

      //   {
      //     text: "All",
      //     value: 'all',
      //   },
      // ],
      geolocationKontenBerita: "",
      provincesKontenBerita: [],
      provincesKontenBeritaWithoutDuplicate: [],
      // socket: io(ipSocket),
      menu: false,
      dialog: false,
      selectedTopic: "",
      selectedTopicNotId: "",
      totalCollectedData: "",
      listValueKeyword: [],
      valueMostTotalKeyword: "",
      valueLeastTotalKeyword: "",
      selectedTopic2: "",
      selectedPeriode: "This Week",
      topicsentiment: [],
      topickeywordsentiment: [],
      periodeberita: ['Today', 'From Yesterday', 'This Week', 'Previous Week', 'This Month', 'Previous Month'],
      isShowDate: false,
      showDateStart: "",
      showDateEnd: "",
      dateStart: new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10),
      dateEnd: new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10),
      updateSocket: "",
      selectedClustering: "",
      statusFilter: "",
      nerPersonSearch: "",
      nerOrganizationSearch: "",
      isClickBuble: "",
      isClickBubleOrg: "",
      isClickWord: "",
      resetcolorClicked: false,
      pagetotalcontent: "",
      pageplay: 100,
      pagestart: "",
      pagelength: "",
      valueKataKunci: "",
      finalObjectFilterLogika: [],
      objFilterLogika: [],
      listObjFilterLogika: [],
      listFilterLogika: [],
      listFilterLogikaLogic: [],
      valueFilterLogika: "Logic Filter",
      itemsFilterLogika: [
        {
          logic: "Logic Filter",
          disabled: false,
        },
        {
          logic: "Or",
          disabled: false,
        },
        {
          logic: "And",
          disabled: false,
        },
        {
          logic: "Not",
          disabled: false,
        },
      ],
      itemsSelectFilterLogika: [],
      selectedLogika: "Or",
      dialogFilterLogika: false,
      alert: false,
      colorAlert: "",
      message: "",
      chartTweet: [],
      chartYt: [],
      chartInstagram: [],
      chartTikTok: [],
      valueTotalTwet: "",
      valueTotalYt: "",
      valueTotalInstagram: "",
      valueTotalTikTok: "",
      chartCombinasi: [],
      kontenBeritaAll: [],
      kontenBerita: [],
      kontenTweet: [],
      kontenYoutube: [],

      /*radial*/
      seriesmedia: [],
      onlinemedia: {
        colors: ["#38BABC", "#16A5A7", "#079092", "#057577", "#025354"],
        chart: {
          height: "50px",
          type: "radialBar",
        },
        plotOptions: {
          radialBar: {
            dataLabels: {
              name: {
                fontSize: "22px",
              },
              value: {
                fontSize: "16px",
              },
              total: {
                show: true,
                label: "Total",
              },
            },
          },
        },
        labels: ["Twitter", "Youtube"],
      },

      seriesdonut: [],
      chartPie: {
        colors: ['#008FFB', '#FF4560', '#00E396'],
        chart: {
          width: 380,
          type: 'pie',
        },
        dataLabels: {
          enabled: false
        },
        plotOptions: {
          pie: {
            donut: {
              labels: {
                show: true,
                name: {
                  show: true,
                  fontSize: '22px',
                  color: '#226077',
                  offsetY: -10,
                },
                total: {
                  show: true,
                },
              }
            }
          }
        },
        labels: ['Netral', 'Negative', 'Positive'],
        legend: {
          show: true,
          position: 'bottom',
          horizontalAlign: 'center',
        },
      },

      // chartDataProv: [
      //   ['Provinces', 'Users'],
      // ],
      chartDataProv2: [],
      // chartOptionsProv: {
      //   region: 'ID',
      //   resolution: 'provinces',
      //   displayMode: 'regions',
      //   colors: ['#0471A5'],
      //   height: '400'
      // },

      chartDataProv: [
        // ['Provinces', 'Users'],
        ['Latitude', 'Longitude', 'City', 'Population'],
        [-6.2088, 106.8456, 'Jakarta', 20], // Jakarta
        [-7.7972, 110.3705, 'Yogyakarta', 30], // Yogyakarta
        [-6.9175, 107.6191, 'Bandung', 15], // Bandung
        [-8.65629, 115.222099, 'Bandung', 2],
        [-0.4101453123155193, 116.96751740598248, 'Bandung', 2],
        // Tambahkan titik lainnya sesuai kebutuhan
      ],
      chartOptionsProv: {
        region: 'ID',
        // resolution: 'provinces',
        // displayMode: 'regions',
        displayMode: 'markers', // Menggunakan mode marker untuk menampilkan titik
        // colorAxis: { colors: ['green', 'blue'] }, // Skema warna untuk marker
        // backgroundColor: '#81d4fa',
        colors: ['#0471A5'],
        height: '400'
      },
    }
  },
  computed: {
    ...mapGetters(['navbarWithName']),
    themeItemColor() {
      const colorTheme = getComputedStyle(document.documentElement).getPropertyValue('--color-theme').trim();
      return colorTheme == '#895700' ? 'var(--color-theme)' : undefined;
    },
    isColorThemeSetneg() {
      const colorTheme = getComputedStyle(document.documentElement).getPropertyValue('--color-theme').trim();
      return colorTheme == '#895700';
    }
  },
  mounted() {
    this.loadTopic();
  },
  beforeDestroy() {
    // Hapus event listener saat komponen dihancurkan
  },
  methods: {
    zoomOut() {
      // Ketika tombol Zoom Out diklik, kita akan meniru menekan ESC
      // this.simulateEscKeyPress();
      this.$refs.clustercarot.resetZoom();
      // this.resetZoom(); 
    },


    openDialogInfo() {
      this.dialogInfo = true;
      setTimeout(() => {
        this.dialogInfo = false;
      }, 10000);
    },
    getTitleRadialBar() {
      const categories = this.chartOptionsRadial.xAxis.categories;
      const data = this.chartOptionsRadial.series[0].data;
      let subtitleContent = '';

      categories.forEach((category, index) => {
        const color = this.chartOptionsRadial.series[0].colors[index];
        subtitleContent += `<span style="color: ${color};">${category}: ${data[index]}</span><br>`;
      });

      this.chartOptionsRadial.title.text = `<span style="font-family: sans-serif; font-size: 14px;">${subtitleContent}</span>`;
    },
    renderFoamtree() {
      if (window.CarrotSearchFoamTree) {
        console.log('FoamTree tersedia.');
        // new FoamTree({
        //   element: this.$refs.foamtree_render,
        //   dataObject: this.dataObject,
        // });
        console.log(window.CarrotSearchFoamTreeInstance)
      } else {
        console.error('FoamTree tidak ditemukan.');
      }
    },
    getRealTimeData() {
      this.socket.on("listUpdate", fetchedData => {
        // Remove non-printable and other non-valid JSON characters
        var s = fetchedData.replace(/\\n/g, "\\n")
                  .replace(/\\'/g, "\\'")
                  .replace(/\\"/g, '\\"')
                  .replace(/\\&/g, "\\&")
                  .replace(/\\r/g, "\\r")
                  .replace(/\\t/g, "\\t")
                  .replace(/\\b/g, "\\b")
                  .replace(/\\f/g, "\\f");
        var dataUpdate = JSON.parse(s);
        console.log(dataUpdate);
        this.kontenBeritaAll = [];
        this.kontenBeritaAll = dataUpdate;
        this.kontenBerita = [];
        this.kontenTweet = [];
        this.kontenYoutube = [];
        for (let i = 0; i < dataUpdate.length; i++) {
          if (dataUpdate[i].source == "berita") {
            this.kontenBerita.push(dataUpdate[i]);
          }
        }
        for (let i = 0; i < dataUpdate.length; i++) {
          if (dataUpdate[i].source == "twitter") {
            this.kontenTweet.push(dataUpdate[i]);
          }
        }
        for (let i = 0; i < dataUpdate.length; i++) {
          if (dataUpdate[i].source == "youtube") {
            this.kontenYoutube.push(dataUpdate[i]);
          }
        }
        this.loadKontenBerita();
        this.updateSocket = true;
      })
    },
    filterBySentiment(event, chartContext, config) {
      this.statusFilter = config.dataPointIndex;
      if (this.statusFilter == 0) {
        this.statusFilter = "Netral";
      }
      if (this.statusFilter == 1) {
        this.statusFilter = "Negative";
      }
      if (this.statusFilter == 2) {
        this.statusFilter = "Positive";
      }
      this.$store.commit("addButtonTmp", {
        // sentiment_glob: this.statusFilter,
        // ner_person_glob: this.$store.ner_person_glob,
        // ner_organization_glob: this.$store.ner_organization_glob,
      });
      this.loadKontenBerita2();
    },
    filterReset() {
      this.$store.commit("addButtonTmp", {
        sentiment_glob: "",
        ner_person_glob: "",
        ner_organization_glob: "",
      });
      this.loadKontenBerita2();
    },
    // update show custom date
    showPeriodeDate() {
      this.isShowDate = true;

      var date = new Date(this.dateStart);
      var day2 = (date.getMonth() > 8 ? date.getMonth() + 1 : "0" + (date.getMonth() + 1)) + "/" +
        (date.getDate() > 9 ? date.getDate() : "0" + date.getDate()) + "/" +
        date.getFullYear();

      const parts = day2.split("/");
      parts.unshift(parts.pop());
      parts[1] -= 1;
      var dateString = new Intl.DateTimeFormat("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
        timeZone: "UTC"
      }).format(Date.UTC(...parts)).replace(/,/g, "");

      dateString = dateString.split(" ");
      this.showDateStart = dateString;

      var date3 = new Date(this.dateEnd);
      var day4 = (date3.getMonth() > 8 ? date3.getMonth() + 1 : "0" + (date3.getMonth() + 1)) + "/" +
        (date3.getDate() > 9 ? date3.getDate() : "0" + date3.getDate()) + "/" +
        date3.getFullYear();

      const parts2 = day4.split("/");
      parts2.unshift(parts2.pop());
      parts2[1] -= 1;
      var dateString2 = new Intl.DateTimeFormat("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
        timeZone: "UTC"
      }).format(Date.UTC(...parts2)).replace(/,/g, "");

      dateString2 = dateString2.split(" ");
      this.showDateEnd = dateString2;

      let jenisParameter = "";
      if (this.selectedPeriode == "Custom") {
        jenisParameter = "custom";
      } else {
        jenisParameter = "periode";
      }

      this.$store.commit("addParameter", {
        jenis_parameter_glob: jenisParameter,
        topic_glob: this.selectedTopic,
        topic_glob2: this.selectedTopic2,
        selectedPeriode_glob: this.selectedPeriode,
        date_start_glob: this.dateStart,
        date_end_glob: this.dateEnd,
        is_show_date_glob: this.isShowDate
      });
    },
    finalObjFilterLogika() {
      let objFilterLogikaIndex0 = [];
      if (this.valueFilterLogika == "Logic Filter") {
        this.objFilterLogika[0].operator = "";
      }
      objFilterLogikaIndex0.push(this.objFilterLogika[0]);
      this.finalObjectFilterLogika = objFilterLogikaIndex0.concat(this.listObjFilterLogika);
      this.$store.commit("addButtonTmp", {
        finalobjectfilterlogika_glob: this.finalObjectFilterLogika,
      });
    },
    updateKataKunci() {
      this.objFilterLogika[0].keyword_logic = this.valueKataKunci;
    },
    disableLogicFilter() {
      for (let i = 0; i < this.itemsSelectFilterLogika.length; i++) {
        this.itemsSelectFilterLogika[i][0].disabled = false;
        this.itemsSelectFilterLogika[i][1].disabled = false;
        this.itemsSelectFilterLogika[i][2].disabled = false;
      }
      this.itemsFilterLogika[0].disabled = true;
      for (let i = 0; i < this.listObjFilterLogika.length; i++) {
        this.listObjFilterLogika[i].operator = this.valueFilterLogika;
      }
      if (this.valueFilterLogika == "Or") {
        for (let i = 0; i < this.itemsSelectFilterLogika.length; i++) {
          this.itemsSelectFilterLogika[i][1].disabled = true;
        }
      }
      if (this.valueFilterLogika == "Not") {
        for (let i = 0; i < this.itemsSelectFilterLogika.length; i++) {
          this.itemsSelectFilterLogika[i][0].disabled = true;
          this.itemsSelectFilterLogika[i][1].disabled = true;
        }
      }
      this.objFilterLogika[0].operator = this.valueFilterLogika;
    },
    changeSelectFilterLogika(logic, index) {
      for (let i = 0; i < this.itemsSelectFilterLogika.length; i++) {
        this.itemsSelectFilterLogika[i][0].disabled = false;
        this.itemsSelectFilterLogika[i][1].disabled = false;
        this.itemsSelectFilterLogika[i][2].disabled = false;
      }
      if (this.listObjFilterLogika[0].operator == "And") {
        let operatorAnd = [];
        for (let i = 0; i < this.itemsSelectFilterLogika.length; i++) {
          operatorAnd.push(this.listObjFilterLogika[i].operator);
        }
        if (operatorAnd.includes("Or")) {
          let indexOr = operatorAnd.indexOf("Or");
          for (let i = indexOr + 1; i < this.itemsSelectFilterLogika.length; i++) {
            this.itemsSelectFilterLogika[i][1].disabled = true;
            this.itemsSelectFilterLogika[0][1].disabled = false;
          }
        }
      }
      if (logic == "Or" && this.listObjFilterLogika[0].operator == "Or") {
        for (let i = 0 + 1; i < this.itemsSelectFilterLogika.length; i++) {
          this.listObjFilterLogika[i].operator = logic;
          this.itemsSelectFilterLogika[i][1].disabled = true;
        }
      }
      if (logic == "Not" && this.listObjFilterLogika[0].operator == "Or") {
        for (let i = 0 + 1; i < this.itemsSelectFilterLogika.length; i++) {
          this.itemsSelectFilterLogika[i][1].disabled = true;
          this.itemsSelectFilterLogika[0][1].disabled = false;
        }
      }
      if (logic == "Not" && this.valueFilterLogika == "Or") {
        for (let i = 0; i < this.itemsSelectFilterLogika.length; i++) {
          this.itemsSelectFilterLogika[i][1].disabled = true;
        }
      }
      // if(logic == "Not" && this.valueFilterLogika == "And"){
      //   for (let i = 0; i < this.itemsSelectFilterLogika.length; i++) {
      //     this.itemsSelectFilterLogika[i][1].disabled = true
      //     this.itemsSelectFilterLogika[0][1].disabled = false
      //   }
      // }
      if (logic == "Or" && this.valueFilterLogika == "Or") {
        for (let i = 0; i < this.itemsSelectFilterLogika.length; i++) {
          this.itemsSelectFilterLogika[i][1].disabled = true;
        }
      }
      if (logic == "And") {
        for (let i = index + 1; i < this.itemsSelectFilterLogika.length; i++) {
          this.listObjFilterLogika[i].operator = logic;
        }
      }
      if (logic == "Or") {
        for (let i = index + 1; i < this.itemsSelectFilterLogika.length; i++) {
          this.listObjFilterLogika[i].operator = logic;
          this.itemsSelectFilterLogika[i][1].disabled = true;
        }
      }
      if (logic == "Not") {
        for (let i = index + 1; i < this.itemsSelectFilterLogika.length; i++) {
          this.listObjFilterLogika[i].operator = logic;
          this.itemsSelectFilterLogika[i][0].disabled = true;
          this.itemsSelectFilterLogika[i][1].disabled = true;
          // this.itemsSelectFilterLogika[i][2].disabled = true
        }
      }
    },
    addFilterLogika() {
      let objFilterLogika = {
        operator: this.selectedLogika,
        keyword_logic: this.valueKataKunci
      };
      let listObjFilterLogika = {
        operator: this.selectedLogika,
        keyword_logic: ""
      };
      let listSelectFilterLogika = [
        {
          logic: "Or",
          disabled: false,
        },
        {
          logic: "And",
          disabled: false,
        },
        {
          logic: "Not",
          disabled: false,
        }
      ];
      this.objFilterLogika.push(objFilterLogika);
      this.listObjFilterLogika.push(listObjFilterLogika);
      this.itemsSelectFilterLogika.push(listSelectFilterLogika);
      this.listFilterLogika.push(this.valueKataKunci);
      this.listFilterLogikaLogic.push(this.selectedLogika);
    },
    addFilterLogikaInList(logic, index) {
      if (logic.operator == "Not" && this.listObjFilterLogika[0].operator == "Or") {
        for (let i = 0; i < this.itemsSelectFilterLogika.length; i++) {
          this.itemsSelectFilterLogika[i][1].disabled = true;
          this.itemsSelectFilterLogika[0][1].disabled = false;
        }
      }
      if (this.listObjFilterLogika[0].operator == "Or" || this.listObjFilterLogika[0].operator == "And") {
        this.selectedLogika = "Or";
      }
      if (this.listObjFilterLogika[0].operator == "Not") {
        this.selectedLogika = "Not";
      }
      let objFilterLogika = {
        operator: logic.operator,
        keyword_logic: logic.keyword_logic
      };
      let listObjFilterLogika = {
        operator: this.selectedLogika,
        keyword_logic: ""
      };
      let listSelectFilterLogika = [
        {
          logic: "Or",
          disabled: false,
        },
        {
          logic: "And",
          disabled: false,
        },
        {
          logic: "Not",
          disabled: false,
        }
      ];
      this.objFilterLogika.push(objFilterLogika);
      this.listObjFilterLogika.push(listObjFilterLogika);
      this.itemsSelectFilterLogika.push(listSelectFilterLogika);
      this.listFilterLogika.push(this.valueKataKunci);
      this.listFilterLogikaLogic.push(this.selectedLogika);
      if (logic.operator == "Or") {
        for (let i = index + 1; i < this.itemsSelectFilterLogika.length; i++) {
          this.itemsSelectFilterLogika[i][1].disabled = true;
        }
      }
      if (logic.operator == "Not") {
        for (let i = index + 1; i < this.itemsSelectFilterLogika.length; i++) {
          this.listObjFilterLogika[i].operator = "Not";
          this.itemsSelectFilterLogika[i][0].disabled = true;
          this.itemsSelectFilterLogika[i][1].disabled = true;
          // this.itemsSelectFilterLogika[i][2].disabled = true
        }
      }
    },
    deleteFilterLogika(i) {
      let listFilterLogika = this.listFilterLogika;
      listFilterLogika.splice(i, 1);
      this.objFilterLogika.splice(i, 1);
      this.listObjFilterLogika.splice(i, 1);
      this.itemsSelectFilterLogika.splice(i, 1);
      let listFilterLogikaAfterDelete = this.listFilterLogika;
      this.listFilterLogika = listFilterLogikaAfterDelete;
    },
    filterByBuble(value) {
      // alert(value);
      this.resetcolorClicked = false;
      this.nerPersonSearch = value;
      this.isClickBuble = value;
      this.$store.commit("addButtonTmp", {
        // sentiment_glob: this.$store.sentiment_glob,
        // ner_person_glob: value,
        // ner_organization_glob: this.$store.ner_organization_glob,
      });
      this.loadKontenBerita2();
    },
    async loadTopic() {
      this.dialog = true;
      axios.get("keyword_select",
        { headers: { 'auth-token': localStorage.getItem('token_app') } },
        { dataType: 'json' }
      )
      .then((response) => {
        // this.posts = response.data;
        // const data = response.data;
        const data_dec = decryptionData(response.data.token);
        this.posts = data_dec.keyword;
        const data = data_dec.keyword;
        // alert(data.length);
        for (let i = 0; i < data.length; i++) {
          //sincron data topic sentiment
          if (i == 0) {
            if (this.$store.topic_glob == "" || this.$store.topic_glob == undefined) {
              this.selectedTopic = data[i].SEQ_ID;
            } else {
              this.selectedTopic = this.$store.topic_glob;
            }
          }
          this.topicsentiment.push(data[i]);
        }
        this.$store.commit("addTopicKeyword", {
          //send parameter store
          topickeywordsentiment_glob: data,
        });
        this.topickeywordsentiment = [];
        let all = "All";
        for (let i = 0; i < data.length; i++) {
          //sincron data topic sentiment
          if (data[i].SEQ_ID == this.selectedTopic) {
            this.topickeywordsentiment.push(all);
            for (let x = 0; x < data[i].KEYWORD.length; x++) {
              if (x == 0) {
                if (this.$store.topic_glob2 == "" || this.$store.topic_glob2 == undefined) {
                  // this.selectedTopic2 = (data[i].KEYWORD[x].KEYWORD);
                  this.selectedTopic2 = all;
                } else {
                  this.selectedTopic2 = this.$store.topic_glob2;
                }
              }
              // alert(data[i].KEYWORD[x].KEYWORD);
              this.topickeywordsentiment.push(data[i].KEYWORD[x].KEYWORD);
            }
            this.selectedTopicNotId = data[i].TOPIC;
            this.selectedTopicTotalCollectedData = data[i].TOPIC;
          }
        }

        this.isShowDate = this.$store.is_show_date_glob;
        var date_start = this.dateStart;
        var date_end = this.dateEnd;
        if (this.$store.jenis_parameter_glob == "custom") {
          date_start = this.$store.date_start_glob;
          date_end = this.$store.date_end_glob;
        } else {
          let period = this.selectedPeriode.toUpperCase().replace(/ /g, '_');
          let date_v = generate_filterdate(period);
          date_start = date_v.start_date;
          date_end = date_v.end_date;
        }

        if (this.$store.date_start_glob == "" || this.$store.date_start_glob == undefined) {
          // send parameter store
          // alert('aaa');
          this.$store.commit("addParameter", {
            jenis_parameter_glob: "periode",
            topic_glob: this.selectedTopic,
            topic_glob2: this.selectedTopic2,
            selectedPeriode_glob: this.selectedPeriode,
            finalobjectfilterlogika_glob: this.finalObjectFilterLogika,
            date_start_glob: date_start,
            date_end_glob: date_end,
            is_show_date_glob: this.isShowDate
          });
        } else {
          this.selectedTopic2 = this.$store.topic_glob2;
          this.selectedPeriode = this.$store.selectedPeriode_glob;
          this.dateStart = this.$store.date_start_glob;
          this.dateEnd = this.$store.date_end_glob;
        }

        this.startDateInfo = date_start;
        this.endDateInfo = date_end;

        // console.log(this.$store.date_start_glob)
        if (data.length > 0) {
          // this.loadKontenBerita2();
            this.loadChartPie();

        }
        if (this.isShowDate == true) {
          this.showPeriodeDate();
        }
      })
      .catch((e) => {
        if (e.response) {
          const { status } = e.response;

          switch (status) {
            case 404:
              this.$refs.alert.error_login(404);
              break;
            case 403:
              this.$refs.alert.error_login(403);
              break;
            default:
              console.log("some other error"); // end up here all the time
              break;
          }
        } else {
          this.alert = true;
          setTimeout(() => {
            this.alert = false;
          }, 10000);
          this.message = "API Keyword Select refused to connect";
          this.colorAlert = "red";
        }
      });
    },

    async parameter_proses_topic() {
      var date_start = this.dateStart;
      var date_end = this.dateEnd;

      this.topickeywordsentiment = [];
      let all = "All";
      for (let i = 0; i < this.$store.topickeywordsentiment_glob.length; i++) {
        //sincron data topic sentiment
        if (this.$store.topickeywordsentiment_glob[i].SEQ_ID == this.selectedTopic) {
          this.topickeywordsentiment.push(all);
          for (let x = 0; x < this.$store.topickeywordsentiment_glob[i].KEYWORD.length; x++) {
            if (x == 0) {
              // this.selectedTopic2 = (this.$store.topickeywordsentiment_glob[i].KEYWORD[x].KEYWORD);
              if (this.$store.topic_glob2 == "" || this.$store.topic_glob2 == undefined) {
                this.selectedTopic2 = all;
              } else {
                this.selectedTopic2 = this.$store.topic_glob2;
              }
            }
            // alert(this.$store.topickeywordsentiment_glob[i].KEYWORD[x].KEYWORD +' - '+ x);
            this.topickeywordsentiment.push(this.$store.topickeywordsentiment_glob[i].KEYWORD[x].KEYWORD);
          }
          this.selectedTopicNotId = this.$store.topickeywordsentiment_glob[i].TOPIC;
        }
      }
      this.$store.commit("addParameter", {
        jenis_parameter_glob: this.$store.jenis_parameter_glob,
        topic_glob2: this.selectedTopic2,
        topic_glob: this.selectedTopic,
        selectedPeriode_glob: this.selectedPeriode,
        finalobjectfilterlogika_glob: this.finalObjectFilterLogika,
        date_start_glob: date_start,
        date_end_glob: date_end,
        is_show_date_glob: this.isShowDate
      });
      // this.loadKontenBerita2()
    },
    async parameter_proses_keyword() {
      var date_start = this.dateStart;
      var date_end = this.dateEnd;
      this.$store.commit("addParameter", {
        jenis_parameter_glob: this.$store.jenis_parameter_glob,
        topic_glob2: this.selectedTopic2,
        topic_glob: this.selectedTopic,
        selectedPeriode_glob: this.selectedPeriode,
        finalobjectfilterlogika_glob: this.finalObjectFilterLogika,
        date_start_glob: date_start,
        date_end_glob: date_end,
        is_show_date_glob: this.isShowDate
      });
    },
    async parameter_proses_periode() {
      let date_start = this.dateStart;
      let date_end = this.dateEnd;
      if (this.selectedPeriode != 'Custom') {
        let period = this.selectedPeriode.toUpperCase().replace(/ /g, '_');
        let date_v = generate_filterdate(period);
        date_start = date_v.start_date;
        date_end = date_v.end_date;
        this.dateStart = date_start;
        this.dateEnd = date_end;
      }

      this.$store.commit("addParameter", {
        jenis_parameter_glob: "periode",
        topic_glob2: this.selectedTopic2,
        topic_glob: this.selectedTopic,
        selectedPeriode_glob: this.selectedPeriode,
        date_start_glob: date_start,
        date_end_glob: date_end,
        is_show_date_glob: this.isShowDate
      });

      this.startDateInfo = date_start;
      this.endDateInfo = date_end;
      this.showPeriodeDate();
    },
    async parameter_proses_custom() {
      this.selectedPeriode = "Custom";

      // alert(this.selectedPeriode);
      var date_start = this.dateStart;
      var date_end = this.dateEnd;

      this.$store.commit("addParameter", {
        jenis_parameter_glob: "custom",
        topic_glob2: this.selectedTopic2,
        topic_glob: this.selectedTopic,
        selectedPeriode_glob: this.selectedPeriode,
        finalobjectfilterlogika_glob: this.finalObjectFilterLogika,
        date_start_glob: date_start,
        date_end_glob: date_end,
        is_show_date_glob: this.isShowDate
      });
      // this.loadKontenBerita2()
    },
    async loadKontenBerita2() {
      this.loadKontenBerita();
      this.selectedClustering = this.selectedTopicNotId;
    },


    async loadChartPie() {
      this.dialog = true;

      if(this.statusFilter  ===  ""){
        this.tabsSentiment = 'Positive'
      }else{
        this.tabsSentiment = this.statusFilter

      }
      
      try {
        
        const authToken = localStorage.getItem('token_app');
        if (!authToken) {
          throw new Error("Auth token not found");
        }
        // chat pie data ====================================================
        const getStoreValue = (key, defaultValue = "") => {
          return this.$store[key] || defaultValue;
        };
        const object_filter_logika = getStoreValue("finalobjectfilterlogika_glob", "");
        const data_chart_pie = await axios.post(
          `tranding-topic-chart-pie?start_date=${this.$store.date_start_glob}&end_date=${this.$store.date_end_glob}&topic=${this.$store.topic_glob}&topic2=${this.$store.topic_glob2}&sentiment=${this.statusFilter}&ner_person=${this.nerPersonSearch}&ner_organization=${this.nerOrganizationSearch}&domain=${this.isClickWord}&logic=${JSON.stringify(object_filter_logika)}&start=0&rows=${this.pageplay}`,
          {},
          {
            headers: {
              'auth-token': authToken,
            },
          }
        );
        this.seriesdonut[0] = data_chart_pie.data.data.count_netral;
        this.seriesdonut[1] = data_chart_pie.data.data.count_negative;
        this.seriesdonut[2] = data_chart_pie.data.data.count_positive;


        this.valueTotalBerita = data_chart_pie.data.data.count_news;
        this.valueTotalTwet = data_chart_pie.data.data.count_twitter;
        this.valueTotalYt = data_chart_pie.data.data.count_youtube;
        this.valueTotalTikTok = data_chart_pie.data.data.count_tiktok;
        this.valueTotalInstagram = data_chart_pie.data.data.count_instagram;
        


// Loop through data and add categories where the value is not empty or zero
        let categories = [];
        if (this.valueTotalTwet !== 0 && this.valueTotalTwet !== null && this.valueTotalTwet !== undefined) {
          categories.push('Twitter');
          this.$set(this.chartOptionsRadial.series[0].data, 0, this.valueTotalTwet);

        }
        if (this.valueTotalYt !== 0 && this.valueTotalYt !== null && this.valueTotalYt !== undefined) {
          categories.push('Youtube');
          this.$set(this.chartOptionsRadial.series[0].data, 1, this.valueTotalYt);

        }
        if (this.valueTotalInstagram !== 0 && this.valueTotalInstagram !== null && this.valueTotalInstagram !== undefined) {
          categories.push('Instagram');
          this.$set(this.chartOptionsRadial.series[0].data, 2, this.valueTotalInstagram);

        }
        if (this.valueTotalTikTok !== 0 && this.valueTotalTikTok !== null && this.valueTotalTikTok !== undefined) {
          categories.push('Tiktok');
          this.$set(this.chartOptionsRadial.series[0].data, 3, this.valueTotalTikTok);

        }
        this.$set(this.chartOptionsRadial.xAxis, 'categories', categories);

// Set the dynamic categories in chartOptionsRadial

        this.getTitleRadialBar();
        
        window.dispatchEvent(new Event("resize"));
        // this.loadContent()
        this.loadCluster()
        this.loadBubble()

        this.dialog = false;
        
      } catch(e) {
        console.log(e);
        this.alert = true;
        setTimeout(() => {
          this.alert = false;
        }, 10000);
        this.message = "API Dashboard Content Response Data Not Found";
        this.colorAlert = "red";
        this.dialog = false;
        // this.loading = false
      }

    },
    
    
    async loadCluster() {
      this.dialog = true;

      if(this.statusFilter  ===  ""){
        this.tabsSentiment = 'Positive'
      }else{
        this.tabsSentiment = this.statusFilter

      }
      
      try {
        
        const authToken = localStorage.getItem('token_app');
        if (!authToken) {
          throw new Error("Auth token not found");
        }
        // chat pie data ====================================================
        const getStoreValue = (key, defaultValue = "") => {
          return this.$store[key] || defaultValue;
        };
        const object_filter_logika = getStoreValue("finalobjectfilterlogika_glob", "");
        
        let period = this.selectedPeriode.toUpperCase().replace(/ /g, '_');
        // alert(period)
        const datafoarm = await axios.post(
          `honeycon-cluster?period=${period}&start_date=${this.$store.date_start_glob}&end_date=${this.$store.date_end_glob}&topic=${this.$store.topic_glob}&topic2=${this.$store.topic_glob2}&sentiment=${this.statusFilter}&ner_person=${this.nerPersonSearch}&ner_organization=${this.nerOrganizationSearch}&domain=${this.isClickWord}&logic=${JSON.stringify(object_filter_logika)}&start=0&rows=${this.pageplay}`,
          {},
          {
            headers: {
              'auth-token': authToken,
            },
          }
        );

        this.getTitleRadialBar();
        console.log('ddddd')
        console.log(datafoarm.data.data.cluster)
        this.$refs.clustercarot.carrot(datafoarm.data.data.cluster);

        window.dispatchEvent(new Event("resize"));
        // this.loadContent()
        this.dialog = false;
        
      } catch(e) {
        console.log(e);
        this.alert = true;
        setTimeout(() => {
          this.alert = false;
        }, 10000);
        this.message = "API Dashboard Content Response Data Not Found";
        this.colorAlert = "red";
        this.dialog = false;
        // this.loading = false
      }

    },
    async loadBubble() {
      this.dialog = true;
      if(this.statusFilter  ===  ""){
        this.tabsSentiment = 'Positive'
      }else{
        this.tabsSentiment = this.statusFilter

      }
      try {
        
        const authToken = localStorage.getItem('token_app');
        if (!authToken) {
          throw new Error("Auth token not found");
        }
        // chat pie data ====================================================
        const getStoreValue = (key, defaultValue = "") => {
          return this.$store[key] || defaultValue;
        };
        const object_filter_logika = getStoreValue("finalobjectfilterlogika_glob", "");
        
        // alert(period)

        const response = await axios.post(
          `tranding-topic-ner?start_date=${this.$store.date_start_glob}&end_date=${this.$store.date_end_glob}&topic=${this.$store.topic_glob}&topic2=${this.$store.topic_glob2}&sentiment=${this.statusFilter}&ner_person=${this.nerPersonSearch}&ner_organization=${this.nerOrganizationSearch}&domain=${this.isClickWord}&logic=${JSON.stringify(object_filter_logika)}&start=0&rows=${this.pageplay}`,
          {},
          {
            headers: {
              'auth-token': authToken,
            },
          }
        );

        const data_dec = decryptionData(response.data.token);
        console.log(data_dec)
        let combinedData =  data_dec.ner_organization.reduce((acc, curr) => {
          return acc.concat(curr.data);
        }, []);
        this.$store.commit("dataBubble", {bubble_data: combinedData});
        this.$refs.topPersonComponent.generatebubble();

        window.dispatchEvent(new Event("resize"));
        // this.loadContent()
        // this.loadChartArea()
        this.dialog = false;
        
      } catch(e) {
        console.log(e);
        this.alert = true;
        setTimeout(() => {
          this.alert = false;
        }, 10000);
        this.message = "API Dashboard Content Response Data Not Found";
        this.colorAlert = "red";
        this.dialog = false;
        // this.loading = false
      }

    },
    
  }
}
</script>

<style scoped>
.custom-date-picker ::v-deep .v-date-picker-table button {
  color: #000000 !important;
}
.custom-date-picker ::v-deep .v-date-picker-table button.v-btn--active {
  background-color: var(--color-theme) !important;
  color: #ffffff !important;
}
.confirm-reset {
  position: absolute; top: 10px; right: 10px;
}

.v-sheet--offset {
  top: -24px;
  position: relative;
}
div.apexcharts-canvas.apexcharts-theme-dark {
  background: transparent !important;
}

.apexcharts-toolbar {
  z-index: 0;
}
.tooltip .tooltip-inner {
  max-width: 100px !important;
  width: 100px !important;
}
.v-tooltip__content {
  font-size: 12px !important;
  max-width: 150px;
}
.row-pointer {
  cursor: pointer;
}

.btn-ok {
  background-image:
  linear-gradient(to right top, #53d166, #5dd468, #65d769, #6eda6b, #76dd6d, #7ee06f, #86e271, #8de573, #96e876, #9fec79, #a8ef7c, #b1f27f);
}
.v-avatar.color-avatar {
  background-image:
  linear-gradient(to right top, #5a6fe8, #6174ea, #6879ed, #6f7fef, #7584f1, #7d8af3, #8590f5, #8d96f7, #989ff9, #a2a7fb, #acb0fd, #b6b9ff);
}
.v-avatar.color-avatar2 {
  background-image:
  linear-gradient(to right top, #ec6497, #ef6d94, #f27693, #f47f92, #f58892, #f78f91, #f99791, #fa9e91, #fca690, #fdae8f, #feb690, #febe91);
}
.v-avatar.color-avatar3 {
  background-image:
  linear-gradient(to right top, #5d8de3, #5c92e4, #5b96e5, #5c9be6, #5d9fe6, #5da3e7, #5ea6e7, #5faae8, #5faee9, #5fb2ea, #60b6eb, #61baec);
}
.buttonstyle {
  box-shadow: 0 5px 15px rgba(153, 0, 255, 0.4);
  background-image:
  linear-gradient(to right top, #5a6fe8, #6174ea, #6879ed, #6f7fef, #7584f1, #7d8af3, #8590f5, #8d96f7, #989ff9, #a2a7fb, #acb0fd, #b6b9ff);
}
.v-avatar.color-avatar5 {
  background-image:
  linear-gradient(to right top, #dc922b, rgb(198, 128, 14), #fec864, #ffcc5e, #ffd057, #ffd359, #ffd65a, #ffd95c, #ffdb66, #ffde6f, #ffe079, #ffe282);
}
</style>
